// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/

export let SegmentEventTypes = /*#__PURE__*/function (SegmentEventTypes) {
  SegmentEventTypes["IDENTIFY"] = "identify";
  SegmentEventTypes["PAGE"] = "page";
  SegmentEventTypes["TRACK"] = "track";
  return SegmentEventTypes;
}({});
export let CrossDomainIdentifierType = /*#__PURE__*/function (CrossDomainIdentifierType) {
  CrossDomainIdentifierType["XC"] = "xc";
  CrossDomainIdentifierType["UID"] = "uid";
  return CrossDomainIdentifierType;
}({});
export let CrossDomainIdentifierState = /*#__PURE__*/function (CrossDomainIdentifierState) {
  CrossDomainIdentifierState["NEW"] = "NEW";
  CrossDomainIdentifierState["CHANGED"] = "CHANGED";
  CrossDomainIdentifierState["EXISTING"] = "EXISTING";
  CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
  CrossDomainIdentifierState["ERROR"] = "ERROR";
  CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
  CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
  CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
  return CrossDomainIdentifierState;
}({});